module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/point-title-2-6e525b2045d82c4b4a51725498d130c3.png";